var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.595 0.747501C8.595 0.937501 8.525 1.1275 8.375 1.2775L1.855 7.7975C1.375 8.2775 1.375 9.0575 1.855 9.5375L8.375 16.0575C8.665 16.3475 8.665 16.8275 8.375 17.1175C8.085 17.4075 7.605 17.4075 7.315 17.1175L0.795 10.5975C-0.265 9.5375 -0.265 7.8075 0.795 6.7375L7.315 0.2175C7.605 -0.0725 8.085 -0.0725 8.375 0.2175C8.515 0.3675 8.595 0.557501 8.595 0.747501Z",
    fill: "#FCEEE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.69ffadd6f5704a958d3f88e9fc78a32f.svg";
export { ForwardRef as ReactComponent };